export { default } from './PageSharedAccess.vue'
